import React, { useState } from "react";
import { useQuery } from "react-query";
import { GetCacheKey } from "../../../services/common/utils";
import Loadingcomponent from "../../../components/loader/loadingcomponent";
import BottomModalDesignComponent from '../../common/bottom-modal-design';

function RoamingPacksBannerDesign({ pmsitem }) {
    const [showErrorModal, setshowErrorModal] = useState(false);
    const toggleerrormodal = () => {
        setshowErrorModal(!showErrorModal);
    }
    const openpopup = () => {
        setshowErrorModal(true);
    }
   

    return (
        <div>
            <div className='banner_section_new'>
                <div className='banners_item'>
                    <h2>ROAMING PASSPORT</h2>
                    <div>
                        <img src={process.env.PUBLIC_URL + '/assets/images/Banners_Ooredoo Passport Countries.png'} alt='Banner' />
                    </div>
                </div>
            </div>
            <div>

                <div class="toast" role="alert" aria-live="assertive" aria-atomic="true">
                    <div class="toast-header">
                        <img src="..." class="rounded me-2" alt="..." />
                        <strong class="me-auto">Bootstrap</strong>
                        <small>11 mins ago</small>
                        <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
                    </div>
                    <div class="toast-body">
                        Hello, world! This is a toast message.
                    </div>
                </div>
            </div>


            {/* products CARD 1 */}
            <div className='products_card'>
                <div className='card_info'>
                    <div className='lft_card'>
                        <div className='fst_card'>
                            <img src='https://stgweb.ooredoo.com.kw/webapis/api/Banner/Getimageweb?id=48&amp;l=en' alt='' />
                            <h5>Passport EU for 60 KD</h5>
                        </div>
                        <p>Unlimited internet 1 TB high speed. 120 Minutes Voice</p>
                    </div>
                    <div class="vr"></div>
                    <div className='rgt_card'>
                        <div>
                        <div className='primary_price' onClick={openpopup}>
                            <h6>KD 12</h6>
                        </div>
                        <div className='secondary_price'>
                            KD 40
                        </div>
                        </div>
                        <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt='price' />
                    </div>
                </div>
                <h6 className='cardsupport_txt '>VIEW SUPPORTED CONTRIES</h6>
            </div>

            {/* card 2 start */}
            <div className='products_card'>
                <div className='card_info'>
                    <div className='lft_card'>
                        <div className='fst_card'>
                            <img src='https://stgweb.ooredoo.com.kw/webapis/api/Banner/Getimageweb?id=48&amp;l=en' alt='' />
                            <h5>Passport EU for 60 KD</h5>
                        </div>
                        <p>Unlimited internet 1 TB high speed. 120 Minutes Voice Unlimited internet 1 TB high speed. 120 Minutes Voice</p>
                    </div>
                    <div class="vr"></div>
                    <div className='rgt_card'>
                        <div className='primary_price'>
                            <h6>KD 12</h6>
                            <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt='price' />
                        </div>
                        {/* <div className='secondary_price'>
                            KD 40
                            </div> */}
                    </div>
                </div>
                {/* <h6 className='cardsupport_txt '>VIEW SUPPORTED CONTRIES</h6> */}
            </div>
            <BottomModalDesignComponent
                show={showErrorModal}
                respmessage="test"
                togglebottomModal={toggleerrormodal}
            ></BottomModalDesignComponent>
        </div>
        
    )
}



export default RoamingPacksBannerDesign;

